<div *ngIf="loading || error" class="sm-flex sm-text-xs" i18n>
  <i class="cc-icon cc-icon-spinner"></i>
</div>

<div *ngIf="!loading && !error">
  <ng-container *ngFor="let person of personsToDisplay; let isLast = last">
    <span *ngIf="person">
      {{ person.archived ? 'Deleted User' : person.fullName ?? 'Missing User'
      }}<ng-container *ngIf="!isLast">,</ng-container>
    </span>
  </ng-container>
</div>
